import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import TopNav from "../../components/navigation/TopNav";
import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import FormField from "../../components/forms/FormField";


const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};

const readOnlyFieldStyle = {
  width: "100%",
  minHeight: "40px",
  padding: "0 12px",
  display: "flex",
  alignItems: "center",
  border: "1px solid var(--color-border, #d0d7de)",
  borderRadius: "8px",
  backgroundColor: "var(--color-surface-muted, #f6f8fa)",
  color: "var(--color-text, inherit)",
  fontSize: "var(--font-size-md)",
  boxSizing: "border-box",
};

export default function UserProfile() {
  const { t } = useTranslation();
  const [userData, setUserData] = useState({
    userno: "",
    fullname: "",
    start_point: "",
    end_point: "",
    sponsor: "",
    user_tax_id: "",
    email: "",
    role: "",
  });

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(`${process.env.REACT_APP_API_URL}/user/profile`)
      .then((res) => {
        setUserData({
          userno: res.data.userno || "",
          fullname: res.data.fullname || "",
          start_point: res.data.start_point || "",
          end_point: res.data.end_point || "",
          sponsor: res.data.sponsor || "",
          user_tax_id: res.data.user_tax_id || "",
          email: res.data.email || "",
          role: res.data.role || "",
        });
      })
      .catch(() => {
        setUserData({
          userno: "",
          fullname: "",
          start_point: "",
          end_point: "",
          sponsor: "",
          user_tax_id: "",
          email: "",
          role: "",
        });
      });
  }, []);

  return (
    <StandardScreen
      topNav={<TopNav title={t("user_profile_form.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("user_profile_form.title")}>
              <Stack gap="3">
                <FormField label={t("user_profile_form.fields.userno.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.userno || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.fullname.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.fullname || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.start_point.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.start_point || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.end_point.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.end_point || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.sponsor.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.sponsor || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.user_tax_id.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.user_tax_id || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.email.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.email || t("common.empty_value")}
                  </div>
                </FormField>

                <FormField label={t("user_profile_form.fields.role.label")}>
                  <div style={readOnlyFieldStyle}>
                    {userData.role
                      ? t(`roles.${userData.role}`)
                      : t("common.empty_value")}
                  </div>
                </FormField>
              </Stack>
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}